import { apiWrapper } from "@/services/api";
import store from "@/store/index";

export const getMyCoupons = async (isNotReCall = false) => {
  try {
    const limit = 100;
    let page = 1;

    let resp;
    let results = [];
    do {
      resp = await apiWrapper(
        "GET",
        `/mfitt/coupons?page=${page}&limit=${limit}`,
        {},
        isNotReCall
      );
      results = [...results, ...resp.data];
      page++;
    } while (resp.data.length == limit);

    store.commit("MFITT/setMyCoupons", results);
    return results;
  } catch (err) {
    console.log('ERROR"" getMyCoupons():', err);
    throw err;
  }
};
